import PlatformApi from './_platformApi';

class OrganizationApi extends PlatformApi {
  controllerName = 'Organizations';

  /**
   * Lấy danh sách đơn vị của user (bao gồm tenants và departments)
   */
  getOrganizations(app) {
    const request = {
      url: this.getAPIUrl() + '/list?appCode=' + (app || ''),
    };
    return this.getAsync(request);
  }

  getLastestWorkingOrganization(app) {
    const request = {
      url: this.getAPIUrl() + '/lastest-organiation?appCode=' + (app || ''),
    };
    return this.getAsync(request);
  }

  /**
   * Chuyển đổi đơn vị làm việc
   * @param {string} departmentId - ID department
   */
  switchOrganization(departmentId) {
    const request = {
      url: this.getAPIUrl() + '/switch',
      data: {departmentId},
    };
    return this.postAsync(request, true);
  }

  isCompleteGettingStarted(appCode, tenantId, budgetCode) {
    const params = new URLSearchParams();
    params.append('appCode', appCode);
    params.append('tenantId', tenantId);
    if (budgetCode) params.append('budgetCode', budgetCode);
    const request = {
      url: `${this.getAPIUrl()}/check-setup-status?${params.toString()}`,
    };
    return this.getAsync(request);
  }

  getRoleApps(tenantId) {
    const request = {
      url: `${this.getAPIUrl()}/role-app?tenantId=${tenantId}`,
    };
    return this.getAsync(request);
  }
}

export default new OrganizationApi();
